'use client'

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { usePathname } from 'next/navigation'

import { AGE_GATE_UNLOCK_EVENT } from '@/constants/ageGate'
import { FormModalQueryGate } from '@/components/FormModalQueryGate'

type FrontendShellProps = {
  children: React.ReactNode
  /** Server-rendered slots — must not import Payload-backed blocks inside this client file */
  footer: React.ReactNode
  initialChoice: 'yes' | 'no' | null
  navbar: React.ReactNode
}

function FrontendShellInner({
  children,
  footer,
  initialChoice,
  navbar,
}: FrontendShellProps) {
  const pathname = usePathname()
  const previousPathnameRef = useRef(pathname)
  const isUnderagePage = pathname === '/underage-drinking'
  const bypassFromServerOrRoute = initialChoice === 'yes' || isUnderagePage
  const [unlockFromAgeGateUi, setUnlockFromAgeGateUi] = useState(false)
  const isUnlocked = bypassFromServerOrRoute || unlockFromAgeGateUi

  const isLocked = !isUnlocked && !isUnderagePage
  const showChrome = pathname !== '/underage-drinking'

  useEffect(() => {
    const handleUnlock = () => {
      setUnlockFromAgeGateUi(true)
    }

    window.addEventListener(AGE_GATE_UNLOCK_EVENT, handleUnlock)
    return () => {
      window.removeEventListener(AGE_GATE_UNLOCK_EVENT, handleUnlock)
    }
  }, [])

  useLayoutEffect(() => {
    if (previousPathnameRef.current === pathname) return

    previousPathnameRef.current = pathname
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])

  return (
    <>
      <div
        aria-hidden={isLocked}
        className={isLocked ? 'pointer-events-none' : undefined}
        style={isLocked ? { visibility: 'hidden' } : undefined}
      >
        {showChrome ? navbar : null}
        {children}
        {showChrome ? footer : null}
      </div>
      <FormModalQueryGate />
    </>
  )
}

export function FrontendShell(props: FrontendShellProps) {
  return <FrontendShellInner {...props} />
}
